import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HTTPService, HelperService, DataService } from 'app/services';

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.scss'],
})
export class AddGroupComponent implements OnInit {
  @Input() isLoading: boolean = false;

  @Output() handleClose = new EventEmitter<any>();

  isProcessing: boolean = false;
  appendText: string = '';
  groupType: any[] = [
    {
      title: 'Customer list',
      value: 'CUSTOMER',
      description:
        'Use filters such as Last Invoice date, Customer tags and Customers activity status to shortlist a group of contacts you would like to reach out to ',
    },
    {
      title: 'Service list',
      value: 'DEFERRED',
      description:
        'Create a group of customers using the services their vehicles got at your shop. Use filters such as Service name, Authorization status, Invoice date, and Customer type',
    },
  ];
  group: any = {
    title: '',
    description: '',
    type: {
      title: 'Customer list',
      value: 'CUSTOMER',
      description:
        'Use filters such as Last Invoice date, Customer tags and Customers activity status to shortlist a group of contacts you would like to reach out to ',
    },
  };

  typeConstants: any = {
    CUSTOMER: 'Customer list',
    DEFERRED: 'Service list',
  };

  marketingGroupId: string = '';
  errors: any = { title: '' };
  isValid: boolean = false;
  campaignId: any;

  constructor(
    private router: Router,
    public ref: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private httpService: HTTPService,
    private helperService: HelperService // private dataService: DataService
  ) {}

  async ngOnInit() {
    const {
      campaignId,
      marketingGroupId,
      isOpenFromCampaign,
    } = this.dialogConfig.data;

    if (marketingGroupId) {
      this.marketingGroupId = marketingGroupId;
      await this.getGroup();
      this.validateData();
    }

    if (isOpenFromCampaign) {
      this.campaignId = campaignId;
    }
  }

  async getGroup() {
    try {
      const {
        type,
        title,
        description,
      } = await this.httpService.getMarketingGroup(this.marketingGroupId);
      this.group.title = title;
      this.group.description = description;
      this.groupType.map((elem) => {
        if (elem.value === type) {
          this.group.type = elem;
        }
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  async navigateToNext() {
    if (this.isLoading || this.isProcessing) return;

    this.isProcessing = true;

    try {
      const group = {
        title: this.group.title,
        type: this.group.type.value,
        description: this.group.description,
      };

      if (!this.marketingGroupId) {
        const { _id } = await this.httpService.saveMarketingGroup(group);

        this.marketingGroupId = _id;
        this.helperService.showToaster(
          'success',
          `Group creation was successful. Next, select your filters to shortlist from ${
            group.type === 'CUSTOMER' ? 'customers' : 'service'
          } list.`
        );
      } else {
        await this.httpService.updateMarketingGroup(
          this.marketingGroupId,
          group
        );
        this.helperService.showToaster(
          'success',
          `Group creation was successful. Next, select your filters to shortlist from ${
            group.type === 'CUSTOMER' ? 'customers' : 'service'
          } list.`
        );
      }
      this.closeDialog();

      if (this.campaignId) {
        const navigationExtras: NavigationExtras = {
          state: { campaignId: this.campaignId },
        };
        this.router.navigate(
          [`/marketing/step-2/${this.marketingGroupId}`],
          navigationExtras
        );
      } else {
        this.router.navigate([`/marketing/step-2/${this.marketingGroupId}`]);
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }

  validateData() {
    this.isValid = !!this.group.title;
  }

  handleChange(key: string, value: any) {
    this.group[key] = value;
    this.validateData();
  }

  /** Close dialog */
  closeDialog(isSuccess: boolean = false, data: any = {}) {
    this.ref.close({ isSuccess, data });
  }
}
